<template>
    <el-select class="tree-select" ref="treeSelect" @visible-change="onPopperVisibleChange" v-model="selectedValue"
        :multiple="multiple" :disabled="disabled" :size="size" :clearable="clearable"
        :popper-class="multiple ? 'tree-select multi-select-tree' : 'tree-select single-select-tree'"
        :collapse-tags="collapseTags" :name="name" :placeholder="placeholder"
        @remove-tag="onRemoveItem">
        <el-option label="全部" value="tree-select-default-all"></el-option>
        <el-option v-for="item in listData" :key="item[nodeKey]" :label="item[props.label || 'label']" :value="item[nodeKey]"></el-option>
    </el-select>
</template>

<script>
import Vue from 'vue'

function getNodes (node, temp, idKey) {
    temp.set(node[idKey], node);
    if (Array.isArray(node.children)) {
        node.children.forEach((item) => {
            getNodes(item, temp, idKey);
        });
    }
}

export default {
    name: 'ElTreeSelect',
    props: {
        value: {
            type: [String, Number, Array]
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'default'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        collapseTags: {
            type: Boolean,
            default: true
        },
        name: {
            type: String
        },
        placeholder: {
            type: String
        },
        data: {
            type: Array
        },
        nodeKey: {
            type: String,
            required: true
        },
        props: {
            type: Object,
            default: function () {
                return {
                    label: 'name',
                    children: 'children',
                    disabled: 'disabled'
                }
            }
        },
        defaultExpandAll: {
            type: Boolean,
            default: false
        },
        expandOnClickNode: {
            type: Boolean,
            default: false
        },
        checkOnClickNode: {
            type: Boolean,
            default: true
        },
        checkStrictly: {
            type: Boolean,
            default: true
        },
        accordion: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            selectedValue: this.value,
            dropdownTree: null,
            mapDatas: new Map()
        }
    },
    methods: {
        onPopperVisibleChange (isVisible) {
            if (isVisible) {
                this.$nextTick(() => {
                    let items = document.getElementsByClassName('el-select-dropdown__item');
                    for (let i = 0; i < items.length; i++) {
                        items[i].style.display = 'none';
                    }
                    let dorpdownList = document.getElementsByClassName('tree-select el-select-dropdown');
                    let dropdownItem = dorpdownList[dorpdownList.length - 1];
                    let parent = dropdownItem.getElementsByClassName('el-select-dropdown__list')[0];
                    let treeNode = parent.getElementsByClassName('el-tree')[0];

                    if (treeNode == null) {
                        let dom = document.createElement('div');
                        parent.appendChild(dom);
                        let Tree = Vue.component('ElTree');
                        this.dropdownTree = new Tree({propsData: {
                            ...this.treeProps
                        }});
                        this.dropdownTree.$on('current-change', (data, node) => {
                            if (!this.multiple) {
                                this.$set(this, 'selectedValue', data.deptId);
                                this.$refs.treeSelect.blur();
                            }
                        });
                        this.dropdownTree.$mount(dom);
                        if (!this.multiple && this.selectedValue != null) {
                            setTimeout(() => {
                                this.dropdownTree.setCurrentKey(this.selectedValue);
                            });
                        }
                    } else {
                        treeNode.style.display = 'block';
                        if (this.dropdownTree != null) {
                            if (this.dropdownTree.getCurrentKey() !== this.selectedValue) {
                                this.dropdownTree.setCurrentKey((this.selectedValue == null || this.selectedValue === '') ? null : this.selectedValue);
                            }
                        }
                    }
                });
            } else {
                let temp;
                if (this.multiple) {
                    temp = this.dropdownTree.getCheckedKeys();
                } else {
                    temp = this.dropdownTree.getCurrentKey();
                }
                
                let dorpdownList = document.getElementsByClassName('tree-select el-select-dropdown');
                let dropdownItem = dorpdownList[dorpdownList.length - 1];
                let parent = dropdownItem.getElementsByClassName('el-select-dropdown__list')[0];
                let treeNode = parent.getElementsByClassName('el-tree')[0];
                treeNode.style.display = 'none';
                this.$set(this, 'selectedValue', temp);
                setTimeout(() => {
                    let items = document.getElementsByClassName('el-select-dropdown__item');
                    for (let i = 0; i < items.length; i++) {
                        items[i].style.display = 'block';
                    }
                }, 200);
            }
        },
        onRemoveItem (tagValue) {
            if (this.dropdownTree != null) {
                let checkedKeys = this.dropdownTree.getCheckedKeys();
                if (checkedKeys.indexOf(tagValue) !== -1) {
                    this.dropdownTree.setCheckedKeys(checkedKeys.filter((item) => {
                        return item !== tagValue;
                    }));
                }
            } else {
                this.$emit('remove-tag', tagValue);
            }
        },
        getListData () {
            this.mapDatas.clear();
            if (Array.isArray(this.data)) {
                this.data.forEach((item) => {
                    getNodes(item, this.mapDatas, this.nodeKey);
                })
            }
        },
        parseNode (node) {
            if (Array.isArray(node) && node.length > 0) {
                let temp = node.filter((item) => {
                    item.leaf__tree_select = !(Array.isArray(item[this.props.children || 'children']) && item[this.props.children || 'children'].length > 0);
                    return true;
                });
                return temp;
            } else {
                return [];
            }
        },
        getChildNodes (node, resolve) {
            if (node.level === 0) {
                return resolve(this.parseNode(this.data));
            } else {
                return resolve(this.parseNode(node.data[this.props.children || 'children']));
            }
        }
    },
    computed: {
        treeProps () {
            let tempProps = {...this.props};
            tempProps.children = tempProps.children + '__tree_select';
            tempProps.isLeaf = 'leaf__tree_select'
            return {
                lazy: true,
                load: this.getChildNodes,
                nodeKey: this.nodeKey,
                defaultExpandAll: this.defaultExpandAll,
                expandOnClickNode: this.expandOnClickNode,
                checkOnClickNode: this.checkOnClickNode,
                checkStrictly: this.checkStrictly,
                accordion: this.accordion,
                props: tempProps,
                showCheckbox: this.multiple,
                defaultCheckedKeys: this.multiple ? this.selectedValue : undefined,
                highlightCurrent: !this.multiple
            }
        },
        listData () {
            if (!Array.isArray(this.selectedValue)) {
                let node = this.mapDatas.get(this.selectedValue);
                if (node != null) {
                    return [node];
                } else {
                    return [];
                }
            } else {
                return this.selectedValue.map((item) => {
                    let node = this.mapDatas.get(item);
                    return node;
                }).filter((item) => {
                    return item != null;
                });
            }
        }
    },
    watch: {
        'data': {
            handler: function (newVal, oldVal) {
                this.getListData();
            },
            immediate: true,
            deep: true
        },
        value: {
            handler: function (newVal, oldVal) {
                this.selectedValue = newVal;
            },
            immediate: true,
            deep: true
        },
        selectedValue: {
            handler: function (newVal, oldVal) {
                if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                    this.$emit('input', newVal);
                    this.$emit('change', newVal);
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/TreeSelect/index.vue